export enum ModuleKind {
    Normal = 'normal',
    Execution = 'execution',
    Template = 'template',
    ProgramTemplate = 'program_template',
    ProgramExecution = 'program_execution',
}
